export default "__VITE_ASSET__DrElurar__"